import { useState, useEffect } from "react"
import { useParams } from 'react-router-dom';
import { fetchContentFulData } from '../actions'
import { blogUrlParam } from "../utilities"
import LblLogo from "../images/LblLogo.png";
import { Footer } from "./Footer"
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

//*********************************************************************/

export default function Blog() {
  
  //*********************************************************************/

  const [hasMounted, setHasMounted] = useState(false);
  const [blog, setBlog] = useState({})
  const [htmlContent, setHtmlContent] = useState("")
  const [loading, setLoading] = useState(true)
  const params = useParams()

  let options = {
    renderNode: {
      'embedded-asset-block': (node) =>
        `<img src="${node.data.target.fields.file.url}"/>`
    }
  }

  useEffect(() => { setHasMounted(true) } ,[])

  //*********************************************************************/

  useEffect(() => {

    fetchContentFulData().then((feed) => {

      feed.items.forEach(blog => {
        
        if (blogUrlParam(blog.fields.title) === params.title) {

          setBlog(blog)
          
          setHtmlContent(documentToHtmlString(blog.fields.content, options))          

          return
        }
      })
      
      setLoading(false)
    })
  }, [])

  //*********************************************************************/

  return (
    <div className="Blog">
      <div id="NavContainer">
        <a href="/"><img className="AppLogo" src={LblLogo} alt="LittleByLittleLabs" /></a>
      </div>
        
      {!loading && blog.fields.content && 
        (
        <div className="BlogContent">
          <div className="BlogHeader">{blog.fields.title}</div>
          <img src={blog.fields.bannerImage.fields.file.url} alt="thumb"/>
          <div className="BlogSubTitle">{blog.fields.subTitle}</div>
          <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
        </div>
        )
      }
      <Footer/>
    </div>
  )

  //*********************************************************************/

}